import router from "./router";
import getPageTitle from "@/utils/get-page-title";
router.beforeEach(async (to, from, next) => {
  if (to.matched.length == 0) {
    next({ path: '/' })
  }

  document.title = getPageTitle(to.meta.title);


  next();
});

router.afterEach(() => { });
